import { IconPropsType } from '..';

export const DiamondCardIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="general=default, betting=default, statuses=default, arrows=default, toggleables=default, signs=default, menus=default, casino=card-vip, currency=default">
      <g id="Vector">
        <path d="M2.36244 13.7949L6.29551 1.73505C6.32979 1.6154 6.3812 1.46155 6.44118 1.38463H2.64521C1.75405 1.38463 1 2.11112 1 3.00001V15.7009C1 16.5898 1.75405 17.3675 2.64521 17.3675H3.9391C2.5938 16.7094 1.88259 15.2222 2.35387 13.8034H2.36244V13.7949Z" />
        <path d="M9.08032 1C9.2517 1 9.41451 1.03419 9.57731 1.08547L17.8805 3.77778C18.7202 4.05128 19.1915 4.96581 18.9259 5.81197L14.9928 17.8889C14.77 18.5385 14.1616 19 13.4418 19C13.2619 19 13.0991 18.9658 12.9363 18.9145H12.9449L4.64169 16.2222C3.98189 16.0085 3.51918 15.4017 3.51918 14.6838C3.51918 14.5043 3.54488 14.3333 3.60486 14.1709L7.52937 2.11111C7.75216 1.46154 8.36055 1 9.08032 1ZM13.2191 9.8547L10.1 14.1111L15.7726 10.6838L13.2191 9.8547ZM9.86865 8.76923L9.88579 14.0427L13.0048 9.78632L9.86865 8.76923ZM7.09236 7.87179L9.663 13.9744L9.64586 8.70085L7.09236 7.87179ZM14.7186 7.36752L13.4247 9.66667L15.9782 10.4957L14.7186 7.36752ZM12.4821 6.64103L13.2448 9.60684L14.5386 7.30769L12.4736 6.64103H12.4821ZM12.3108 6.5812L9.94577 8.52991L13.082 9.54701L12.3193 6.5812H12.3108ZM9.95434 5.82051L9.76583 8.47863L12.1308 6.52991L9.95434 5.82051ZM9.78296 5.76068L7.04095 7.58974L9.59445 8.4188L9.78296 5.76068Z" />
      </g>
    </g>
  </svg>
);
